<svg width="110" height="110" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3378_1507)">
        <rect width="110" height="110" rx="55" fill="#E7FAF6" />
        <rect x="25" y="28" width="60" height="84" rx="4" fill="#00BD9D" />
        <path d="M31 26H79V24C79 22.8954 78.1046 22 77 22H33C31.8954 22 31 22.8954 31 24V26Z" fill="#00BD9D" />
        <rect x="53" y="34" width="4" height="12" fill="#E7FAF6" />
        <rect x="61" y="38" width="4" height="12" transform="rotate(90 61 38)" fill="#E7FAF6" />
        <rect x="31" y="52" width="12" height="8" fill="#E7FAF6" />
        <rect x="67" y="52" width="12" height="8" fill="#E7FAF6" />
        <rect x="49" y="52" width="12" height="8" fill="#E7FAF6" />
        <rect x="31" y="66" width="12" height="8" fill="#E7FAF6" />
        <rect x="67" y="66" width="12" height="8" fill="#E7FAF6" />
        <rect x="49" y="66" width="12" height="8" fill="#E7FAF6" />
        <rect x="39" y="84" width="16" height="31" stroke="#E7FAF6" stroke-width="2" />
        <rect x="55" y="84" width="16" height="31" stroke="#E7FAF6" stroke-width="2" />
    </g>
    <rect x="1.5" y="1.5" width="107" height="107" rx="53.5" stroke="#00BD9D" stroke-width="3" />
    <defs>
        <clipPath id="clip0_3378_1507">
            <rect width="110" height="110" rx="55" fill="white" />
        </clipPath>
    </defs>
</svg>